import React from "react"
import NoteApp from './Mongo/MongoNotes'

  export default function Notes () {
  
    return (
        <React.Fragment>
          
            <NoteApp />
         
             
            </React.Fragment>
            );
    }



